// Обратный отсчёт до конца акции.
//
// Считаем не от часов устройства, а от server_time: если у пользователя сбиты
// дата или таймзона, отсчёт всё равно останется верным — локальные часы нужны
// только чтобы понять, сколько времени прошло с момента ответа бэка.

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

// Бэк присылает "2026-09-10 T23:59:59+05:00" — с лишним пробелом перед T.
// Такую строку Safari не парсит, поэтому нормализуем: заодно чиним вариант
// с пробелом вместо T ("2026-09-10 23:59:59+05:00").
export const parsePromotionDate = (value?: string | null) => {
  if (!value) return null;

  const normalized = value.trim().replace(/\s+T/, "T").replace(/\s+/, "T");
  const time = Date.parse(normalized);

  return Number.isNaN(time) ? null : time;
};

// Сколько миллисекунд остаётся до дедлайна на момент ответа сервера.
// null — если дат нет или они нечитаемые, 0 — если акция уже кончилась.
export const getPromotionMsLeft = (
  serverTime?: string | null,
  endDate?: string | null,
) => {
  const end = parsePromotionDate(endDate);
  if (end === null) return null;

  // Без server_time падаем на часы устройства — лучше, чем не показать ничего.
  const start = parsePromotionDate(serverTime) ?? Date.now();

  return Math.max(0, end - start);
};

// "27д 18ч 59м" — дни показываем только когда они есть, иначе строка распухает.
export const formatPromotionLeft = (
  msLeft: number,
  units: { day: string; hour: string; minute: string },
) => {
  const days = Math.floor(msLeft / DAY);
  const hours = Math.floor((msLeft % DAY) / HOUR);
  const minutes = Math.floor((msLeft % HOUR) / MINUTE);

  if (days > 0) {
    return `${days}${units.day} ${hours}${units.hour} ${minutes}${units.minute}`;
  }

  if (hours > 0) {
    return `${hours}${units.hour} ${minutes}${units.minute}`;
  }

  return `${minutes}${units.minute}`;
};
